"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userActions = void 0;
var userActions = {
  SUMMARY: {
    VIEW: "view_summary",
    TITLE: "summary"
  },
  TRANSACTION: {
    VIEW: "txn_view",
    DOWNLOAD: "txn_dwnld",
    TITLE: "transactions"
  },
  TRANSACTIONS_OFFERS: {
    DOWNLOAD: "offer_dwnld",
    TITLE: "offers"
  },
  SETTLEMENT: {
    VIEW: "stlmnt_view",
    DOWNLOAD: "stlmnt_dwnld",
    TITLE: "settlements"
  },
  ON_HOLD_SETTLEMENT: {
    VIEW: "stlmnt_view",
    DOWNLOAD: "stlmnt_dwnld",
    TITLE: "settlements",
    UPDATE: "update_amlock_txn_details"
  },
  STLMNT_TXNS: {
    VIEW: "stlmnt_view",
    DOWNLOAD: "stlmnt_dwnld",
    TITLE: "settlements"
  },
  REFUND: {
    VIEW: "refund_view",
    PROCESS: "refund_process",
    DOWNLOAD: "refund_dwnld",
    TITLE: "refunds"
  },
  BUTTON: {
    VIEW: "buttns_view",
    MANAGE: "buttns_manage",
    DOWNLOAD: "buttns_view",
    TITLE: "buttons"
  },
  PAYMENT_LINKS_LIST: {
    VIEW: "pm_links_view",
    MANAGE: "pm_links_manage",
    DOWNLOAD: "pm_links_view",
    TITLE: "payment-links"
  },
  PAYMENT_GATEWAY: {
    KEY_SALT: "key_salt"
  },
  PAYMENT_HANDLE: {
    VIEW: "pm_handle_view",
    MANAGE: "pm_handle_manage",
    TITLE: "payment-handle"
  },
  PAYOUT: {
    MAKER: "payout_maker",
    CHECKER: "payout_checker",
    MANAGE: "payout_manage",
    DOWNLOAD: "payout_download",
    TITLE: "payouts",
    ANY: "any_scope"
  },
  INVOICES: {
    VIEW: "invoices_view",
    MANAGE: "invoices_manage",
    DOWNLOAD: "invoices_view",
    TITLE: "invoices",
    CREATE_CUSTOMER: "invoices_create_customer",
    CREATE_ITEM: "invoices_create_item"
  },
  SETTINGS: {
    MANAGE_PROFILE: "manage_profile",
    MANAGE_NOTIFICATIONS: "manage_notifications",
    MANAGE_WEBHOOKS: "manage_webhooks",
    MANAGE_CHECKOUT: "manage_checkout",
    MANAGE_TEAM_ACCOUNTS: "manage_team_accounts",
    MANAGE_OUTLETS: "manage_outlets"
  },
  CHARGEBACK: "chrgback",
  PAYMENT_LINKS_TNXS_LIST: {
    DOWNLOAD: "pm_links_view"
  },
  BATCH_PAYMENT_LINKS_LIST: {
    DOWNLOAD: "pm_links_view",
    TITLE: "batch payment-links"
  },
  BULK_UPLOADS_LIST: {
    DOWNLOAD: "pm_links_view"
  },
  TDR: {
    DOWNLOAD: "stlmnt_view",
    TITLE: "settlements"
  },
  PAYOUT_DEPOSITS: {
    DOWNLOAD: "payout_manage",
    TITLE: "payouts"
  },
  PAYOUT_TRANSFERS: {
    DOWNLOAD: "payout_download",
    TITLE: "payouts"
  },
  SETTLEMENT_ITEMS: {
    DOWNLOAD: "stlmnt_dwnld"
  },
  BUTTON_TRANSACTIONS: {
    DOWNLOAD: "buttns_manage"
  },
  REPORTS_LIST: {
    ACCESS: "reports_list"
  },
  NEO_BANKING: {
    ACCESS: "banking"
  },
  NEO_MARKETPLACE: {
    ACCESS: "marketplace"
  },
  ACCOUNT_PAYABLES: {
    OWNER: "account_payables_owner",
    ACCOUNTANT: "account_payables_accountant"
  },
  NEO_ONBOARDING: {
    MANAGE: "neo_onboarding"
  },
  NEO_LENDING: {
    ACCESS: "lending"
  },
  SETTLEMENT_CYCLE: {
    VIEW: "read_settlement_cycle",
    UPDATE: "update_settlement_cycle"
  },
  AGGREGATOR: {
    RELEASE_SETTLEMENT: "release_settlement"
  }
};
exports.userActions = userActions;